<template>
    <b-form-group :class="{ 'has-error': state === false }">
        <div class="d-flex">
            <h6 class="mr-auto">{{ question + (isRequired ? '*' : '') }}</h6>
        </div>
        <ConceptualInput
            v-if="scaleFormat == 'conceptual'"
            :state="state"
            :model="degreeId"
            :degrees="degrees"
            :hasScore="hasScore"
            :disabled="disabled"
            :isNullable="isNullable"
            @change="onChange"
        />
        <NumericInput
            v-else
            :score="score"
            :hasScore="hasScore"
            :disabled="disabled"
            :degrees="degrees"
            :isNullable="isNullable"
            @change="onChange"
        />
        <slot name="loaders"></slot>
        <b-form-invalid-feedback id="answers-group-feedback" :state="state">
            {{ $t('form.validations.answerRequired') }}
        </b-form-invalid-feedback>
    </b-form-group>
</template>
<script>
import { NumericInput, ConceptualInput } from './components'
export default {
    components: {
        NumericInput,
        ConceptualInput,
    },
    props: {
        state: Boolean,
        hasScore: Boolean,
        score: String | Number,
        notAbleToAnswer: Boolean,
        degreeId: String | Number,
        scaleFormat: {
            type: String,
            required: true,
        },
        question: {
            type: String,
            required: true,
        },
        degrees: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        isNullable: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onChange(score, degreeId) {
            if (this.disabled) {
                return
            }

            const notAbleToAnswer = this.isNotAbleToAnswer(score, degreeId)

            this.emitUpdateEvent('score', score)
            this.emitUpdateEvent('degreeId', degreeId)
            this.emitUpdateEvent('notAbleToAnswer', notAbleToAnswer)
            this.emitChangeEvent(score, degreeId)
        },
        isNotAbleToAnswer(score, degreeId) {
            return degreeId == null && score == null
        },
        emitUpdateEvent(prop, value) {
            this.$emit(`update:${prop}`, value)
        },
        emitChangeEvent(value) {
            this.$emit('change', value)
        },
    },
}
</script>
